import React from 'react';
import Header from '../../Components/Header';


const HotelDetail = () => (
  <>
    <Header></Header>
    <section className='Booking_flight'>
    <div className='container_box'>
      <div className='row'>
        <div className='col-12 col-md-9'>
          <div className='box_shadow check_out_bg'>
            <div class="row mamage_depo">
              <div class="col-lg-6">
                <h3 className='sub_headings'>Payment</h3>
              </div>
              <div class="col-lg-6">
                <a href="/Hotel/HotelBooking" class="click_back"><i class="fa fa-arrow-left"></i></a>
              </div>
              <div className="col-12 col-lg-12">
                <div className="paymnt">
                  <div className="paymnt_lft">
                    <ul class="nav nav-tabs paynt" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#AgencyCredit">Agency Credit</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#CreditCard">Credit Card</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#DebitCard">Debit Card</a>
                      </li>
                    </ul>
                  </div>
                  <div className="paymnt_Rgt">
                    <div class="tab-content">
                      <div id="AgencyCredit" class="container tab-pane active">
                        <div className="balnce"><i className="fa fa-inr"></i>89565</div>
                      </div>
                      <div id="CreditCard" class="container tab-pane fade">
                        <div className="balnce"><i className="fa fa-inr"></i>1895</div>
                      </div>
                      <div id="DebitCard" class="container tab-pane fade">
                        <div className="balnce"><i className="fa fa-inr"></i>36565</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-5 mb-5">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" id="Active" name="Status" type="checkbox" value="1" />
                  <label class="form-check-label Active" for="Active"> By clicking this button, I understand &amp; accept with the	Rules &amp; Restrictions of this fare,the Privacy Policy <a data-bs-toggle="modal" data-bs-target="#term-cond" class="weak">Terms &amp; Conditions</a></label>
                </div>
              </div>
              <div className='col-12 col-md-12 text-end'>
                <div class="button-list">
                  <a class="btn-btn-border" href="/Hotel/HotelBooking">Back To</a>
                  {/* <a class="btn btn-primary contnt" href="/hotel/CheckOut">Make Payment</a> */}
                  <button class="btn btn-primary">Pay & Book</button>
                </div>
              </div>

            </div>
          </div>




        </div>
         <div className='col-12 col-md-3'>
              <div className='box_shadow'>
                <h6>Fare Summary</h6>
                <div class="accordion" id="kt_accordion_1">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="kt_accordion_1_header_1">
                      <button class="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_1" aria-expanded="true" aria-controls="kt_accordion_1_body_1">
                        <div className='flex'>
                          <span> Base Fare</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_1" class="accordion-collapse collapse show" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                      <div class="accordion-body">
                        <div className='flex'>
                          <span> Adult(s)</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="kt_accordion_1_header_2">
                      <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_2" aria-expanded="false" aria-controls="kt_accordion_1_body_2">
                        <div className='flex'>
                          <span>Fee & Surcharges</span>
                          <span> <i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_2" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_2" data-bs-parent="#kt_accordion_1">
                      <div class="accordion-body">
                        <div className='flex'>
                          <span> Fuel Surcharge</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                        <div className='flex'>
                          <span> Tax</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                        <div className='flex'>
                          <span> Booking Surcharge</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="kt_accordion_1_header_3">
                      <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_3" aria-expanded="false" aria-controls="kt_accordion_1_body_3">
                        <div className='flex'>
                          <span>Total Fare</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_3" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_3" data-bs-parent="#kt_accordion_1">
                      <div class="accordion-body">
                        <div className='flex'>
                          <span> Markup</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                        <div className='flex'>
                          <span> Commission</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                        <div className='flex'>
                          <span> Net Fare</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='d-flexes'>
                  <div className='totals'>GRAND TOTAL</div>
                  <div className='tolt_price'><i className='fa fa-inr'></i> 8797</div>
                </div>
              </div>
            </div>
      </div>
    </div>
</section>
  </>

);

export default HotelDetail;
